import { getToken } from "../../../shared/utils/common";

export class CommandSetTemplateStatic {
  async run(templateId: number, isStatic: boolean) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ad_templates/${templateId}/`;
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${getToken()} `,
        },
        body: JSON.stringify({ type: isStatic ? "static" : "video" }),
      })
        .then((response) => response.json())
        .then((json) => json)
        .catch((err) => console.log(err));
      if (response) {
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
}
